import styled from 'styled-components';

export const Info = styled.div.withConfig({ displayName: '-Info' })`
	display: inline-block;
	top: 15px;
	left: 0px;
	overflow: visible;
	margin-left: 5px;
	font-weight: bold;


	&:hover::after{
		
		position: absolute;
		top: -14px;
		right: 20px;
		border: 2px solid #C4C4C4;
		background-color: #ffffff;
		color: #000000;
		display: none;
		border-radius: 3px;
		z-index: 999;
		content: "${props => props.label}";
		display: block;
		font-size: 9px;
		color: #C4C4C4;
		font-weight: normal;
		padding: 3px;
	}
`;
